export default "__VITE_ASSET__BxNrGbku__"